module.exports = __webpack_public_path__ + "static/media/menu_profile.048156fd.svg";